import { Box, Typography, useMediaQuery } from '@mui/material';
import { ReactComponent as RefreshIcon } from '../../assets/images/refresh.svg';
import CustomPieChart from '../charts/CustomPieChart';
import { useState } from 'react';

const PlanByPurpose = ({ type }: { type: 'shuffle' | 'trice' }) => {
  const [time, setTime] = useState(new Date().toLocaleString('en-US', { timeZone: 'UTC', hour12: true }));
  const isMobile = useMediaQuery('(max-width:900px)');

  return (
    <Box mt="58px">
      <Typography variant="h3" color="#242424">
        Distribution And Retention Plan By Purpose
      </Typography>

      <Box
        mt="20px"
        sx={{
          background: '#D9D9D91A',
          borderRadius: '20px',
          pt: { xs: '16px', md: '21.26px' },
          pb: { xs: '18px', md: '0px' },
          pl: { xs: '16px', md: '53.91px' },
          pr: { xs: '16px', md: '51.63px' },
        }}
      >
        <Box mb="67px" sx={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Box
            sx={{
              display: 'flex',
              gap: '6px',
              alignItems: 'center',
              height: '14px',
            }}
          >
            <Typography
              sx={{
                fontSize: { xs: '9px', md: '12px' },
                lineHeight: { xs: '11px', md: '14px' },
                letterSpacing: 0,
                color: '#5D5D5D',
              }}
            >
              Standard Time: {time}
            </Typography>

            <div
              onClick={() => {
                setTime(new Date().toLocaleString('en-US', { timeZone: 'UTC', hour12: true }));
              }}
            >
              <RefreshIcon width={isMobile ? 6 : 8} height={isMobile ? 6 : 8} color={'#5D5D5D'} />
            </div>
          </Box>
        </Box>
        <Box>
          <CustomPieChart type={type} />
        </Box>
      </Box>

      <Box mt="10px" ml={{ xs: '16px', md: '53.48px' }}>
        {type === 'shuffle' ? (
          <Typography
            sx={{
              fontWeight: '400',
              fontSize: { xs: '9px', md: '10px' },
              lineHeight: '24px',
              letterSpacing: '-0.02em',
              color: '#5D5D5D',
            }}
          >
            * Inflation Reward : AssetFi Reserve / Shuffle Inflation Compensation
          </Typography>
        ) : (
          <Typography
            sx={{
              fontWeight: '400',
              fontSize: { xs: '9px', md: '10px' },
              lineHeight: '16px',
              letterSpacing: '-0.02em',
              color: '#5D5D5D',
            }}
          >
            * Staking Rewards: 3,500,000 TRIs Each Year / 5% Decrease In Unlock Mounts Upon Reaching 1095 Days.
            <br /> * The Expansion And Reduction Of Rewards From Inflation Is In Line With Governance Policies.
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default PlanByPurpose;
